export const main = document.body.querySelector('main')
export const page = (main) ? main.dataset.page : null;
